<template>
    <draggable
      v-model="internalUsuarios"
      item-key="id"
      group="vendedores"
      @end="onDragEnd"
    >
      <template #item="{ element, index }">
        <div class="accordion mb-2" v-if="element && element.id">
          <div class="accordion-item">
            <button
              class="accordion-button collapsed card-table-txt"
              data-bs-toggle="collapse"
              :data-bs-target="'#row-' + element.id"
              :class="[
                'table-linha',
                'draggable-row',  
                getStatusClass(element),
                { 'table-active': isDragging && currentDrag === element.id }
              ]"
            >
              {{ index + 1 + ")" }}

              <!-- Ícone de arraste -->
              {{element.vendedor.username }}
            </button>
            <div :id="'row-' + element.id" class="accordion-collapse collapse">
              <div class="accordion-body">
                <div class="d-flex align-items-center justify-content-between">
                   <p class="mb-0">
                    <strong>Tipo Vendedor:</strong>
                     {{ element.vendedor.tipo_vend[0]?.tipo_vendedor === 1 ? 'Novo' : 
                element.vendedor.tipo_vend[0]?.tipo_vendedor === 2 ? 'Usado' : 
                element.vendedor.tipo_vend[0]?.tipo_vendedor === 3 ? 'Ambos' : 
                'Não definido' }}
                  </p>
                 </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </draggable>
</template>

<script>
import { ref, watch } from "vue";
import draggable from "vuedraggable";

export default {
  components: { draggable },
  props: {
    usuarios: {
      type: Array,
      required: true,
      validator: (value) =>
        Array.isArray(value) && value.every((item) => "id" in item),
    },
  },
  emits: ["update:usuarios", "reordenado"],
  setup(props, { emit }) {
    const internalUsuarios = ref([...props.usuarios]);
    const isDragging = ref(false);
    const currentDrag = ref(null);

    watch(
      () => props.usuarios,
      (newVal) => {
        internalUsuarios.value = [...newVal];
      }
    );

    const onDragEnd = () => {
      isDragging.value = false;
      currentDrag.value = null;
      emit("update:usuarios", internalUsuarios.value);
      emit("reordenado", internalUsuarios.value);
    };

    const getStatusClass = (item) => {
      if (!item?.status_vendedor) return "";
      return {
        "table-disponivel": item.status_vendedor.includes("Disponível"),
        "table-indisponivel": item.status_vendedor.includes("Indisponível"),
        "table-em-atendimento": item.status_vendedor.includes("Bloqueado"),
      };
    };

    const editItem = (item) => {
      console.log("Editar:", item);
    };

    const deleteItem = (id) => {
      console.log("Deletar:", id);
    };

    return {
      internalUsuarios,
      isDragging,
      currentDrag,
      onDragEnd,
      getStatusClass,
      editItem,
      deleteItem,
    };
  },
};
</script>

<style scoped>
.sortable-ghost {
  opacity: 0.7;
  background: #e9ecef;
}

.sortable-chosen {
  background-color: #f8f9fa;
}

.table-active {
  background-color: rgba(0, 123, 255, 0.1) !important;
}

/* Estilo para toda a linha arrastável */
.draggable-row {
  cursor: move;
  user-select: none;
}

/* Opcional: destaque ao arrastar */
.draggable-row:active {
  cursor: grabbing;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.table-linha {
  transition: all 0.3s ease;
}

/* Prevenir seleção de texto durante o arraste */
.table-linha * {
  user-select: none;
  -webkit-user-select: none;
}
</style>
